/**
 * Shared constants for merchandiser-template lists (PD-15559). A template is
 * either in use or retired — `isActive` is the only state it carries, and the
 * list defaults to showing the active ones.
 */
export const MERCHANDISER_TEMPLATE_ACTIVE_VALUE_MAPPING = [
	{
		value: 'Active',
		label: 'Active',
		color: { type: 'success' },
	},
	{
		value: 'Retired',
		label: 'Retired',
		color: { type: 'muted' },
	},
];
